module.exports = __webpack_public_path__ + "static/media/escritorio.5846fc5f.svg";